import { ActionsMenu, ActionsMenuItem } from '@/components/ActionsMenu';
import TrashIcon from '@/components/Icons/TrashIcon';
import { useDeleteOrgSharedEndpoint } from '@/sections/SharedEndpoints/hooks';

import { ActionsProps } from './types';

function Actions({ variant, sharedEndpointId, sharedEndpointName }: ActionsProps) {
  const deleteOrgSharedEndpoint = useDeleteOrgSharedEndpoint(sharedEndpointName, sharedEndpointId);
  return (
    <ActionsMenu variant={variant}>
      <ActionsMenuItem
        destructive
        onClick={deleteOrgSharedEndpoint}
        data-cy="shared-endpoint-card-setting-delete-btn"
        icon={<TrashIcon />}
      >
        Delete Model API
      </ActionsMenuItem>
    </ActionsMenu>
  );
}

export default Actions;
